import { useEffect, useRef } from "react";

import { ROUTE_PATH } from "@/common/constants/routing";
import { RoutingHelper } from "@/common/helpers/routing";
import { UrlHelper } from "@/common/helpers/url";
import { useAuthenticationInfo } from "@/common/hooks/auth/useAuthenticationInfo";
import { useCurrentTenantInfoV2 } from "@/common/hooks/entity/tenant/useCurrentTenantInfoV2";
import { useTenantProfile } from "@/common/hooks/entity/tenant/useTenantProfile";
import { useAppHistory } from "@/common/hooks/routing/useAppHistory";
import { useQueryParams } from "@/common/hooks/useQueryParams";
import { GeneralQueryParams } from "@/common/ts/GeneralQueryParams";
import { TenantStatus } from "@/core/api/generated/v1";

/** Ensures tenant account is not suspended. If suspended, redirects to error page. */
export function TenantAccountAppGuard() {
  const { ...generalQueryParams } = useQueryParams<GeneralQueryParams>();

  const history = useAppHistory();

  // NB: ensure authorized API endpoints aren't called if user is not authenticated to avoid redirects to login on 401
  const authenticationInfo = useAuthenticationInfo();
  // const authorizationInfo = useAuthorizationInfo();
  // const { authorizationProfile } = useAuthorizationProfile();
  const tenantInfo = useCurrentTenantInfoV2();
  const tenantProfile = useTenantProfile({ isSkipFetch: !authenticationInfo.isAuthenticated });

  const isRedirectingRef = useRef(false);

  useEffect(() => {
    // if (!authorizationInfo.isPermissionsReady) {
    //   return;
    // }
    if (isRedirectingRef.current) {
      return;
    }

    const currentUrl = UrlHelper.getCurrentUrl();
    const redirectUrl = generalQueryParams.redirectUrl || currentUrl;

    // redirect to suspended page if tenant is suspended
    if (
      authenticationInfo.isAuthenticated &&
      RoutingHelper.isFleetAreaActive() &&
      tenantInfo.isTenantContext &&
      tenantProfile &&
      tenantProfile.status === TenantStatus.Suspended
    ) {
      console.log("Guard. Redirecting to tenant account suspended page...", {
        authenticationInfo,
        tenantInfo,
        tenantProfile,
      });
      isRedirectingRef.current = true;
      history.push(
        ROUTE_PATH.ERROR_TENANT_ACCOUNT_SUSPENDED({
          ...generalQueryParams,
          redirectUrl,
        }),
      );
      return;
    }
  }, [authenticationInfo, tenantInfo, tenantProfile]);

  return null;
}
